import { AgGridReact } from "ag-grid-react";
import React, { useEffect, useState } from "react";
import {
  funderaddplayer,
  funderschoolplayerdelete,
  funderschoolplayerlist,
  funderwiseplayerlist,
} from "../../../../services/common";
import { useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import { Modal } from "react-bootstrap";
import {
  allplayerlist,
  schoolactivelist,
} from "../../../../services/superadmin";
import { schoollistcityreg } from "../../../../services/cityregionaladmin";
import { toast } from "react-toastify";
import moment from "moment";
import dotracking from "../../../trackinglogs";
import trackobj from "../../../trackingpages.json";
import Swal from "sweetalert2";
export const FunderPlayerList = () => {
  const { id } = useParams();
  const [filterProduct, setFilterProduct] = useState([]);
  const [schlist, setSchList] = useState([]);
  const [schid, setSchId] = useState("");
  const [alist, setAList] = useState([]);
  const [avalue, setAValue] = useState([]);

  const columnDefs = [
    {
      headerName: "Actions",
      width: 100,
      field: "user_id",
      resizable: true,
      filter: false,
      cellRenderer: function (params) {
        return (
          <div className="text-center" >
            <a title="Delete Player" className="btn-sm btn-secondary me-1" onClick={() => viewpla(params.value,params.data)}>
              <i className="fa fa-eye fa-lg"></i>
            </a>
            <a title="Delete Player" className="btn-sm btn-danger" onClick={() => deletepla(params)}>
              <i className="fa fa-trash fa-lg"></i>
            </a>
          </div>
        );
      },
    },
    {
      headerName: "UID",
      field: "username",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Name",
      field: "first_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
      valueGetter: function sumField(params) {
        var evt = "";
        if (params.data.first_name !== null) {
          evt = params.data.first_name;
        }
        if (params.data.last_name !== null) {
          if (params.data.last_name !== "") {
            if (evt === "") {
              evt = params.data.last_name;
            } else if (evt !== "") {
              evt = evt + " " + params.data.last_name;
            }
          }
        }
        return evt;
      },
    },
    {
      headerName: "Email",
      field: "email_id",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Mobile",
      field: "mobile_no",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Gender",
      field: "gender",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "DOB",
      field: "date_of_birth",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        if (params.data.date_of_birth !== null) {
          return moment(params.data.date_of_birth).format("DD-MM-YYYY");
        }
      },
    },
  ];

  function viewpla(did, edata) {
    dotracking(
      "view icon in all players list for player " +
        edata.first_name +
        " (" +
        edata.username +
        " - " +
        did +
        ") $$ " +
        trackobj.playerdetheading
    );
    const url = window.location.href;
    const head = url.split("/#/");
    if (localStorage.getItem("Role") === "1") {
      window.open(`${head[0]}/#/superadmin/funderviewplayer/` + did + "/" + id, "_blank");
    } 
  }
  useEffect(() => {
    listall();
    if (localStorage.getItem("Role") === "1") {
      schoolactivelist().then((response) => {
        if (response.status === true) {
          let arr1 = [];
          if (response.data.details.length !== 0) {
            for (let i = 0; i < response.data.details.length; i++) {
              arr1.push({
                value: response.data.details[i].id,
                label:
                  response.data.details[i].school_unique_no +
                  " - " +
                  response.data.details[i].school_name,
              });
            }
          }
          setSchList(arr1);
        }
      });
    } 

    listpla("");
  }, []);

  function listall() {
    if (localStorage.getItem("Role") === "1") {
      funderwiseplayerlist(id).then((res) => {
        if (res.status === true) {
          setFilterProduct(res.data.players_list);
        }
      });
    }
  }
  const [show, setShow] = useState(false);
  const [errmsg, setErrMsg] = useState("");
  function handleshow() {
    setAValue([]);
    setSchId("");
    setErrMsg("");
    setShow(true);
  }

  function handleClose() {
    setShow(false);
    setAValue([]);
    setSchId("");
    setErrMsg("");
  }
  function handleSchool(e) {
    if (e !== null) {
      setSchId(e);
      listpla(e.value);
    } else {
      setSchId("");
      listpla("");
    }
  }
  function handleChange(e) {
    if (e !== null) {
      setAValue(e);
    } else {
      setAValue([]);
    }
  }

  function listpla(lsch) {
    if (lsch === "") {
      if (localStorage.getItem("Role") === "1") {
        allplayerlist(1, 6).then((response) => {
          if (response.status === true) {

            let arr1 = [];
            if (response.data.length !== 0) {
              for (let i = 0; i < response.data.length; i++) {
                arr1.push({
                  value: response.data[i].user_id,
                  label:
                    response.data.players_list[i].username +
                    " - " +
                    response.data.players_list[i].first_name,
                });
              }
            }
            setAList(arr1);
          }
        });
      }
    } else {
      funderschoolplayerlist(lsch).then((response) => {
        if (response.status === true) {
          let arr1 = [];
          if (response.data.players_list.length !== 0) {
            for (let i = 0; i < response.data.players_list.length; i++) {
              arr1.push({
                value: response.data.players_list[i].player_id,
                label:
                  response.data.players_list[i].username +
                  " - " +
                  response.data.players_list[i].first_name,
              });
            }
          }
          setAList(arr1);
        }
      });
    }
  }

  function addplayer(e) {
    e.preventDefault();
    let plid = "";
    let playerIds = "";
    if (avalue.length !== 0) {
      const temp = new FormData();
      temp.append("funder_id", id);
      temp.append("admin_id", localStorage.getItem("UID"));
      temp.append("player_count", avalue.length);
      for (let i = 0; i < avalue.length; i++) {
        plid = avalue[i].value;
        if (playerIds !== "") {
          playerIds += ",";
        }

        playerIds += plid;

        temp.append("player_id_" + [i + 1], avalue[i].value);
      }
      dotracking(
        "submit button in player list for funder " +
          id +
          " with players ( " +
          playerIds +
          ") $$ " +
          trackobj.fundetheading
      );
      funderaddplayer(temp).then((res) => {
        if (res.status === true) {
          handleClose();
          toast.success(res.message);
          listall();
        }
      });
    } else {
      setErrMsg("Please Select Player");
    }
  }

  function deletepla(ddata) {
    Swal.fire({
      text: "Are you sure want to Delete?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#ac0404",
      cancelButtonColor: "#6259ca",
      confirmButtonText: "Delete",
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        dotracking(
          "delete in funder player list for " +
            ddata.data.first_name +
            " (" +
            ddata.data.username +
            " - " +
            ddata.data.user_id +
            ") $$ " +
            trackobj.playerlistheading
        );

        funderschoolplayerdelete(ddata.data.table_id).then((response) => {
          if (response.status === true) {
            listall();
            toast.success(response.message);
          }
        });
      }
    });
  }
  const navigate = useNavigate();
  function backlist() {
    dotracking("back button in player list $$ " + trackobj.addfunderlist);
    navigate("/superadmin/funderlist");
  }

  return (
    <div className="side-app">
      <div className="page-header">
        <div className="breadcrumb">
          <h4 className="mb-0">Funder Player Lists</h4>
        </div>
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a>Funder</a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            Funder Player Lists
          </li>
        </ol>
      </div>

      <div className="row">
        <form className="card mt-0">
          <div className="card-body">
            <div className="col-12 text-right">
              <a className="btn btn-success me-2" onClick={handleshow}>
                Add Players
              </a>

              <a className="btn btn-gray" onClick={backlist}>
                Back
              </a>
            </div>

            <div className="ag-theme-alpine ag-style mt-2">
              <AgGridReact
                columnDefs={columnDefs}
                rowData={filterProduct}
                pagination="true"
                paginationPageSize="10"
                sortingOrder={["asc", "desc"]}
                suppressExcelExport={true}
                suppressDragLeaveHidesColumns={true}
              />
            </div>

            <Modal show={show} size="md">
              <Modal.Header>
                <h4>Add Player</h4>
              </Modal.Header>
              <Modal.Body>
                <div className="row">
                  <div className="col-12">
                    <div className="form-group">
                      <label className="mb-2">Select School</label>
                      <Select
                        placeholder="Select School"
                        value={schid}
                        options={schlist}
                        onChange={handleSchool}
                        isSearchable={true}
                      />
                    </div>
                  </div>

                  <div className="col-12">
                    <div className="form-group">
                      <label className="mb-2">
                        Select Player <span className="errortext"> *</span>
                      </label>
                      <Select
                        placeholder="Select Player"
                        value={avalue}
                        options={alist}
                        onChange={handleChange}
                        isSearchable={true}
                        isMulti
                      />
                    </div>
                  </div>
                </div>
                {errmsg && <span className="errortext">{errmsg}</span>}
              </Modal.Body>
              <Modal.Footer>
                <a className="btn btn-success" onClick={addplayer}>
                  Submit
                </a>
                <a className="btn btn-secondary" onClick={handleClose}>
                  Close
                </a>
              </Modal.Footer>
            </Modal>
          </div>
        </form>
      </div>
    </div>
  );
};
